'use strict';

goog.provide("Ntry.ScriptContainer");

goog.require("Ntry.STATIC");

Ntry.ScriptContainer = function(script) {
    this.script = script.script || "";
    this.timeStamp = new Date().getTime();
}

Ntry.ScriptContainer.prototype.type =
    Ntry.STATIC.SCRIPT_CONTAINER;
